import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';
// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.#handleClick, { signal }); // Changed to use private method
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  #handleClick = (event) => { // Changed to private method
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    const shouldPreventDefault = (isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop);

    if (shouldPreventDefault) {
      event.preventDefault();
      return;
    }

    // Only close others if this accordion is about to be opened
    // The details element will toggle its 'open' state naturally if preventDefault isn't called.
    // So, if it's currently closed and a click occurs, it will open.
    // In that case, we want to close others.    
    if (!this.details.open) {
      AccordionCustom.closeOtherAccordions(this);
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();
    
    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));      
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  }

  /**
   * Closes all other open accordions on the page except the one provided.
   * @param {AccordionCustom} currentAccordion - The accordion that is currently being interacted with.
   */
  // static closeOtherAccordions(currentAccordion) {

  //   console.log("currentAccordion");
  //   console.log(currentAccordion.classList);
  //   console.log("currentAccordion");

  //   document.querySelectorAll('accordion-custom').forEach((accordion) => {
  //     if (accordion !== currentAccordion && accordion.details.open) {
  //       accordion.details.open = false;
  //     }
  //   });
  // }


  static closeOtherAccordions(currentAccordion) {
  console.log("currentAccordion");
  console.log(currentAccordion.classList);
  console.log("currentAccordion");

const isFacetsItem = currentAccordion.classList.contains('facets__item') ||
                     currentAccordion.classList.contains('facets__sort__item');


  if (isFacetsItem) {
    // If it's a facets__item, close all inside the facets-form-component.accordion-custom

    if(currentAccordion.classList.contains('facets__sort__item')){

    }else{
    document.querySelectorAll('facets-form-component accordion-custom')
      .forEach((accordion) => {
        if (accordion.details.open) {
          accordion.details.open = false;
        }
      });
    }
  } else {
    // Default behavior: close all others
    document.querySelectorAll('accordion-custom').forEach((accordion) => {
      if (accordion !== currentAccordion && accordion.details.open) {
        accordion.details.open = false;
      }
    });
  }
}

}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}